import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { Auth } from 'Pages/auth'
import { Id } from 'Types/aliases'

async function updateProfile(
	id: number | string,
	data: Partial<Omit<Auth, 'avatar'>> & { avatar?: string }
) {
	const res = await axiosDS().patch<Auth>(`${urls.common.catalogs.user}/${id}`, { data })
	return res.data
}

async function updatePassword(
	id: number | string,
	data: {
		old_password: string
		password: string
		confirm_password: string
	}
) {
	const res = await axiosDS().patch<Auth>(
		urls.auth.updateAuthorizationData.replace(':id', String(id)),
		{
			data,
		}
	)
	return res.data
}

async function updateLogin(
	id: number | string,
	data: {
		old_password: string
		username: string
	}
) {
	const res = await axiosDS().patch<Auth>(
		urls.auth.updateAuthorizationData.replace(':id', String(id)),
		{
			data,
		}
	)
	return res.data
}
async function postEmailConfirmation(scope?: string) {
	const data = { data: { scope } }
	const res = await axiosDS().post(urls.common.email.email_confirmation, data)
	return res.data
}

async function enableTwoFactorAuth(userId: Id, confirmation_code: string) {
	const url = urls.user.two_factor_auth.enable.replace(':id', String(userId))
	const config = confirmation_code
		? {
				extendHeaders: {
					EmailConfirmationCode: confirmation_code?.replace(/[а-яёА-ЯЁ]/g, ''),
				},
		  }
		: undefined
	const res = await axiosDS(config).patch(url, {})
	return res.data
}
async function disableTwoFactorAuth(userId: Id) {
	const res = await axiosDS().patch(
		urls.user.two_factor_auth.disable.replace(':id', String(userId))
	)
	return res.data
}
export const profileApi = {
	updateProfile,
	updatePassword,
	updateLogin,
	enableTwoFactorAuth,
	disableTwoFactorAuth,
	postEmailConfirmation,
}
